import { VzPageContainer } from "../../layouts/VzPageContainer";
import { useEffect, useState } from "react";
import { Modal, Row, Col, Container, Button } from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css";
import { connect } from "react-redux";
import { getUserBlockList, toggleUserBlockStatus } from "./ManageUsersAction";
import ServerSideDataTable from "../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import Moment from "react-moment";

const UserBlockList = (props) => {
  const columns = [
    {
      Header: "Module Type",
      accessor: "module",
    },
    {
      Header: "User Name",
      accessor: "userName",
    },
    {
      Header: "CNIC",
      accessor: "cnic",
    },
    {
      Header: "Contact No.",
      accessor: "contactNumber",
    },
    {
      Header: "Category",
      accessor: "category",
    },
    
    {
      Header: "VIZ ID",
      accessor: "vizShopCode",
    },
    
    {
      Header: "Shop Name",
      accessor: "vizShopName",
    },
    
    {
      Header: "E-mail",
      accessor: "email",
    },
    {
      Header: "Action",
      id: "isLock",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div>
          <button
            title="Toggle User Lock Status"
            onClick={() => toggleBlock(original.userName, original.id)}
            className=" btn btn-sm"
            style={{ color: "#e84d15", backgroundColor: "transparent" }}
          >
            <i
              className={
                original.isLock
                  ? "fas fa-toggle-on fa-2x"
                  : "fas fa-toggle-off fa-2x"
              }
            ></i>
          </button>
        </div>
      ),
    },
  ];

  //Pagination
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");

  const getData = (page) => {
    setCurrentPageNo(page);

    let requestData = {
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
    };

    props.getUserBlockList(requestData);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);

    let requestData = {
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
    };

    props.getUserBlockList(requestData);
  };

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setSearchText(text);
  };

  useEffect(() => {
    setCurrentPageNo(0);

    let requestData = {
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
    };

    props.getUserBlockList(requestData);
  }, [searchText]);

  const toggleBlock = async (userName, userId) => {
    await props.toggleUserBlockStatus(userName , userId);
    let requestData = {
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
    };

    await props.getUserBlockList(requestData);
  };

  useEffect(() => {
    if (props.Users && props.Users.length > 0) {
      setTotalRecords(props.Users[0].totalRecords);
    } else {
      setTotalRecords(0);
    }
  }, [props.Users]);

  return (
    <div>
      <VzPageContainer title="Settings > User Block List">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>User Block List</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <ServerSideDataTable
              data={props.Users ?? []}
              columns={columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    Users: state.Users?.getUserBlockList ? state.Users.getUserBlockList : [],
  };
};
export default connect(mapStateToProps, {
  getUserBlockList,
  toggleUserBlockStatus,
})(UserBlockList);
